var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenderF(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1636",
    "data-name": "Groupe 1636",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.878,
    height: 60,
    viewBox: "0 0 20.878 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3217",
    "data-name": "Trac\\xE9 3217",
    d: "M14140.87,1611.013a6.473,6.473,0,1,1,6.472,6.472,6.472,6.472,0,0,1-6.472-6.472",
    transform: "translate(-14136.581 -1604.541)",
    fill: "#0F893D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3218",
    "data-name": "Trac\\xE9 3218",
    d: "M14150.935,1662.546h-7.074a1.481,1.481,0,0,1-1.584-1.14l-2.025-20.86,1.991-15.331a1.493,1.493,0,0,1,1.581-1.109h7.146a1.491,1.491,0,0,1,1.581,1.114l1.913,15.4-1.944,20.783a1.479,1.479,0,0,1-1.584,1.143",
    transform: "translate(-14137.035 -1602.546)",
    fill: "#0F893D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3219",
    "data-name": "Trac\\xE9 3219",
    d: "M14157.194,1641.572l-9.321,3.083a1.178,1.178,0,0,1-.748,0l-9.12-3.077a1.318,1.318,0,0,1-.838-1.184.9.9,0,0,1,.012-.223l2.147-14.324a8.44,8.44,0,0,1,16.706.081l2,14.243a1.179,1.179,0,0,1,.012.211,1.321,1.321,0,0,1-.847,1.192",
    transform: "translate(-14137.164 -1603.259)",
    fill: "#0F893D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderF);
export default __webpack_public_path__ + "static/media/gender_F.304a63532644f28029eca439c3ffee34.svg";
export { ForwardRef as ReactComponent };